module.exports = __webpack_public_path__ + "img/personal-center-slide-grey.37af2383.svg";